<template>
  <h1 class="heading text-lg font-light leading-7 tracking-widest md:text-2xl md:leading-9">
    <slot />
  </h1>
</template>
